<template>
	<!-- 会员中心页面 -->
	<div class="home">
		<div class="isReady" v-if="!isLoading" :class="{ bgTop: isHome }">
			<publicHeader :pageTitle="pageTitle" v-if="!isHome"></publicHeader>
			<div class="zhanwei" v-if="!isHome"></div>
			<!-- 个人中心 -->
			<div class="contents userInfo">
				<div class="infoMain">
					<!-- 头像 -->
					<div class="userImg" @click="gotoLogin($event)">
						<img v-if="userInfo.userHeadImg" :src="userInfo.userHeadImg" alt=""
							:class="{ borImg: userInfo.userHeadImg }" />
					</div>
					<!-- 中间信息 -->
					<div class="vipInfo">
						<!-- 已登录 -->
						<div class="userName" @click="gotoLogin($event)">
							{{ userInfo.userName }}
						</div>
						<div class="info iconList" v-if="userVipIcon.length">
							<div class="iconItem" v-for="(item, index) in userVipIcon" :key="index">
								<img :src="item" alt="" />
							</div>
						</div>
						<div class="info iconList" v-else>
							购买后享受更多会员服务
						</div>
					</div>
					<!-- 按钮 -->
					<div class="handleBtn" @click="gotoExchange" v-if="!this.$CONFIG.isVerify && this.vipExchange">
						会员兑换
					</div>
				</div>
			</div>
			<!-- 会员类型 -->
			<div class="contents vipType">
				<div class="vipList">
					<div class="typeItem" v-for="(item, index) in vipListFilter" :key="index" :class="{
              firstOdd: index === 0 && vipListFilter.length % 2 === 0,
              firstEven: index === 0 && vipListFilter.length % 2 !== 0
            }" @click="gotoPay(item.id, item.type, item)">
						<div class="flex1">
							<!-- 会员名称/icon -->
							<div class="vipName">
								<div class="icon_vip">
									<img :src="item.logo" alt="" />
								</div>

								<div class="name">{{ item.name }}</div>
							</div>
							<!-- 会员状态 -->
							<div class="vipStatus">
								{{ item.desc }}
							</div>
						</div>

						<!-- 价格/按钮 -->
						<div class="handle">
							<div class="price">
								<div class="num">{{ item.subPrice }}</div>
								<span>元起</span>
								<!-- <div class="num">{{item.price}}</div> <span>元起</span> -->
							</div>
							<div class="handleBtn">
								<div v-if="item.vipState === 1">开通</div>
								<div v-if="item.vipState === 2">续费</div>
								<div v-if="item.vipState === 3">购买</div>
								<div v-if="item.vipState === 4" style="color:#613F25">
									已购买
								</div>
							</div>
						</div>
						<!-- 续费优惠Icon -->
						<div class="renew" v-if="item.showDiscount">
							续费优惠
						</div>
						<!-- 促销宣传语 -->
						<div class="renew slogan" v-if="item.promoteSale != ''">
							{{ item.promoteSale }}
						</div>
					</div>
				</div>
			</div>
			<!-- 会员活动 -->
			<div class="contents" v-if="vipActivity.length > 0" :class="{ norp: vipActivity.length > 3 }">
				<div class="activity">
					<!-- 一张图片 -->
					<div class="pic1" v-if="vipActivity.length === 1" @click="gotoAct(vipActivity[0].address)">
						<img :src="vipActivity[0].img1" alt="" />
						<div class="title">{{ vipActivity[0].title }}</div>
						<!-- <div class="cover"></div> -->
					</div>
					<!-- 两张图片 -->
					<div class="pic2" v-if="vipActivity.length === 2">
						<div class="picItem" v-for="(item, index) in vipActivity" :key="index"
							@click="gotoAct(item.address)">
							<img :src="item.img2" alt="" />
							<div class="title">{{ item.title }}</div>
							<!-- <div class="cover"></div> -->
						</div>
					</div>
					<!-- 多张图片 -->
					<div class="picmore" v-if="vipActivity.length > 2">
						<div class="picItem" v-for="(item, index) in vipActivity" :key="index"
							@click="gotoAct(item.address)">
							<img :src="item.img2" alt="" />
							<div class="title">{{ item.title }}</div>
							<!-- <div class="cover"></div> -->
						</div>
					</div>
				</div>
			</div>
			<!-- 会员福利社 -->
			<div class="contents" v-if="vipWelfare.length">
				<div class="vipWelfare">
					<div class="titleSty">
						<div class="title">会员福利社</div>
						<div class="more" @click="gotoWelfare">更多 <i></i></div>
					</div>
					<div class="couponsList">
						<div class="couponItem" v-for="(item, index) in vipWelfare" :key="index">
							<div class="leftInfo" @click="gotoDetail(item.actId)">
								<div class="couponPrice">
									<div class="num"><span>￥</span>{{ item.money }}</div>
									<div class="other">
										<div class="word">优惠券</div>
										<div class="man">{{ item.useConditionShow }}</div>
									</div>
								</div>
								<div class="condition">{{ item.getRangeShow }}</div>
							</div>
							<div class="rightInfo" @click="getReceiveCoupon(item.actId)">
								立即领取
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 会员权益 -->
			<div class="contents">
				<div class="vipRights">
					<div class="titleSty">
						<div class="title">会员权益</div>
					</div>
					<div class="rightsBox">
						<template v-for="(item, index) in vipRights">
							<div v-if="index == 2" :key="index"></div>
							<div class="rightsItem" v-else :key="index">
								<div class="itemIcon">
									<img :src="
                      `https://images.zhibo.tv/2020/1109/icon_rights${index +
                        1}@2x.png`
                    " alt="" />
								</div>
								<div class="itemName">
									{{ item.name }}
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
			<!-- 会员直播 -->
			<div class="contents" v-if="vipLives.length > 0">
				<div class="vipLives">
					<div class="titleSty">
						<div class="title">会员直播</div>
					</div>
					<div class="livesBox">
						<div class="liveItem" v-for="(item, index) in vipLives" :key="index"
							:class="{ firstLive: vipLives.length % 2 !== 0 && index === 0 }"
							@click="gotoLiveDetail(item.needLogin, item.roomId)">
							<!-- 封面 -->
							<div class="poster">
								<img :src="item.imgUrl" alt="" />
								<!-- 直播图标icon -->
								<div class="icon_living"></div>
							</div>
							<div class="liveInfo">
								<!-- 标题 -->
								<div class="liveTitle">
									{{ item.title }}
								</div>
								<div class="otherInfo">
									<div class="anchorName">
										{{ item.nickname }}
									</div>
									<div class="hot">
										<div class="icon_hot"></div>
										{{ item.roomViewerNum }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 会员专享视频 -->
			<div class="contents">
				<div class="vipVideos">
					<div class="titleSty">
						<div class="title">会员专享视频</div>
						<div class="more" @click="gotoVIPVideo">更多 <i></i></div>
					</div>
					<div class="videosBox">
						<div class="videoItem" v-for="(item, index) in vipVideos" :key="index"
							@click="gotoVideoDeatil(item.id)">
							<div class="poster">
								<img :src="item.imgUrl" alt="" v-if="item.imgUrl" />
								<!-- 会员图标icon -->
								<div class="icon_vip"></div>
								<!-- 视频时长 -->
								<div class="cover">
									<div class="time">
										{{ item.totalTimes | TotalTimeFilter }}
									</div>
								</div>
							</div>
							<div class="title">
								{{ item.title }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 其他服务 -->
			<div class="contents serves">
				<div class="serveItem" @click="gotoVipPrivilege">
					会员服务协议
				</div>
				<div class="serveItem" @click="gotoVipHelp">
					会员帮助
				</div>
				<div class="serveItem" @click="callKefu">
					联系客服
				</div>
				<div class="serveItem" @click="gotoRecord">
					会员记录
				</div>
			</div>
			<publicDialog :info="info" :dialogType="dialogType" :title="title" :btn1="btn1" :btn2="btn2"
				@changeShow="showDialog" :dialogIsShow="dialogIsShow" v-show="dialogIsShow" @openPay="openPay">
			</publicDialog>
			<publicCouponDialog v-if="showCouponDialog" :vipCouponDialogInfo="vipCouponDialogInfo"
				:showCouponDialog="showCouponDialog" @changeCouponDialog="changeCouponDialog"
				@handleOpenVip="handleOpenVip"></publicCouponDialog>
		</div>
		<div class="isLoading" v-else>
			<img src="https://images.zhibo.tv/2021/0308/icon_loading@10x.png" alt="" />
		</div>
	</div>
</template>

<script>
	import publicCouponDialog from '../components/publicCouponDialog.vue'
	import publicDialog from '../components/PublicDialog'
	import publicHeader from '../components/PublicHeader'
	export default {
		name: 'Home',
		components: {
			publicDialog,
			publicHeader,
			publicCouponDialog
		},
		data() {
			return {
				pageTitle: '会员中心',
				// dialog的提示内容
				dialogIsShow: false,
				info: '领取成功',
				title: '提示',
				btn1: '',
				btn2: '我知道了',
				// 是否登录
				// isLogin: false,
				// 个人信息
				userInfo: {
					uihoster: 0,
					userHeadImg: '',
					userId: '',
					userName: '立即登录',
					vipDesc: '购买会员享受更多服务',
					vipLogo: 'https://t100-file.zhibo.tv/images/vip_pay_v3/icon1_gray.png'
					// vipLogo: [{ vipIcon: 'https://t100-file.zhibo.tv/uploads/new_upload/image/20200612/20200612110016_94956.png', vipType: 1, vipName: '羽毛球' }, { vipIcon: 'https://t100-file.zhibo.tv/uploads/new_upload/image/20200612/20200612110016_94956.png', vipType: 1, vipName: '羽毛球' }, { vipIcon: 'https://t100-file.zhibo.tv/uploads/new_upload/image/20200612/20200612110016_94956.png', vipType: 1, vipName: '羽毛球' }, { vipIcon: 'https://t100-file.zhibo.tv/uploads/new_upload/image/20200612/20200612110016_94956.png', vipType: 1, vipName: '羽毛球' }]
				},
				// 会员icon
				userVipIcon: '',
				// 会员类型
				vipList: [],

				// 会员活动
				vipActivity: [
					// { img1: 'https://file.zhibo.tv/uploads/new_upload/images/program/2020/1102/16043589265fa0930e7e1b9_1024x676.jpg', img2: 'https://file.zhibo.tv/uploads/new_upload/images/program/2020/1102/16043589265fa0930e7e1b9_1024x676.jpg', url: 'https://www.baidu.com/' },
					// { img1: 'https://file.zhibo.tv/uploads/new_upload/images/program/2020/1102/16043589265fa0930e7e1b9_1024x676.jpg', img2: 'https://file.zhibo.tv/uploads/new_upload/images/program/2020/1102/16043589265fa0930e7e1b9_1024x676.jpg', url: 'https://www.baidu.com/' },
					// { img1: 'https://file.zhibo.tv/uploads/new_upload/images/program/2020/1102/16043589265fa0930e7e1b9_1024x676.jpg', img2: 'https://file.zhibo.tv/uploads/new_upload/images/program/2020/1102/16043589265fa0930e7e1b9_1024x676.jpg', url: 'https://www.baidu.com/' },
					// { img1: 'https://file.zhibo.tv/uploads/new_upload/images/program/2020/1102/16043589265fa0930e7e1b9_1024x676.jpg', img2: 'https://file.zhibo.tv/uploads/new_upload/images/program/2020/1102/16043589265fa0930e7e1b9_1024x676.jpg', url: 'https://www.baidu.com/' }
				],
				// 会员福利社
				vipWelfare: [],
				//会员权益
				vipRights: [{
						name: '赛事随心看'
					},
					{
						name: '彩色弹幕'
					},
					{
						name: '生日祝福'
					},
					{
						name: '观赛券'
					},
					{
						name: '商品折扣'
					},
					{
						name: '全服喇叭'
					},
					{
						name: '免广告'
					},
					{
						name: '会员蓝光'
					},
					{
						name: '进场道具'
					}
				],
				// 会员直播
				vipLives: [],
				// 会员专享视频
				vipVideos: [],
				// 会员兑换
				vipExchange: '',
				// 客服信息
				serviceInfo: '',
				token: '',
				// 是否是app首页
				isHome: false,
				// 加载中
				isLoading: true,
				scroll: '',
				pageSource: '',
				na: '',
				id: '',
				type: '',
				dialogType: '',
				// 20210729领券条件不满足，开通会员弹窗
				vipCouponDialogInfo: {
					num: 2, // 1单个会员 >1多个会员
					vipList: [{
							vipName: '乒乓球会员',
							vipId: 1
						},
						{
							vipName: '羽毛球会员',
							vipId: 2
						}
					]
				},
				showCouponDialog: false
			}
		},
		created() {
			this.pageSource = this.$route.query.pageSource || ''
			this.isHome = this.getcommit('isHome')
			this.na =
				navigator.userAgent.indexOf('Mac OS') > -1 ||
				!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
			console.log(this.isHome)
			// alert(window.location.href)
			this.getToken()
			document.title = '会员中心'
			this.isIOS = this.$CONFIG.isIOS
			// alert(window.devicePixelRatio);
			this.getVipInfo()
		},
		mounted() {
			console.log(this.vipListFilter)
			window.addEventListener('scroll', this.handleScroll)
			this.scroll = window.sessionStorage.getItem('scroll')
			console.log(this.scroll)
			// alert(this.scroll)
			// this.$nextTick(() => {
			//   document.body.scrollTop = 400
			// })
			this.buryingPoint()
			// if (this.scroll > 0) {
			//   window.scrollTo(0, this.scroll);
			//   this.scroll = 0;
			//   window.addEventListener('scroll', this.handleScroll);
			// }
		},
		computed: {
			vipListFilter() {
				return this.vipList.filter(function(item){
					if((item.id!=52||item.vipState!=1) && (item.id!=104||item.vipState!=3) && (item.id!=104||item.desc!='已过期')){
						return item
					}
				})
			}
		},
		updated() {
			// alert(this.scroll)
			document.body.scrollTop = this.scroll
			window.scrollTo(0, this.scroll)
		},
		// activated () {
		//   this.scroll = window.sessionStorage.getItem('scroll')
		//   if (this.scroll > 0) {
		//     window.scrollTo(0, this.scroll);
		//     this.scroll = 0;
		//     window.addEventListener('scroll', this.handleScroll);
		//   }
		// },
		// deactivated () {
		//   window.removeEventListener('scroll', this.handleScroll);
		// },
		destroyed() {
			console.log('需要销毁')
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			// 20210725新加
			openPay() {
				let host = window.location.host
				console.log(host)
				// 普通会员
				if (this.isHome && this.type === 1) {
					if (this.isIOS) {
						// this.$router.push(`/vipiospay/?id=${id}&type=1&fromh5=1&token=${this.token}`)
						let url = `https://${host}/h5vip/vipiospay/?id=${this.id}&type=1&token=${this.token}`
						console.log(url)
						this.jumpweb(url, 0, '#222224')
					} else {
						// this.$router.push(`/vippay/?id=${id}&type=1&fromh5=1&token=${this.token}`)
						let url = `https://${host}/h5vip/vippay/?id=${this.id}&type=1&token=${this.token}`
						console.log(url)
						this.jumpweb(url, 0, '#222224')
					}
				} else {
					if (this.isIOS) {
						this.$router.push(
							`/vipiospay/?id=${this.id}&type=1&fromh5=1&token=${this.token}`
						)
					} else {
						this.$router.push(
							`/vippay/?id=${this.id}&type=1&fromh5=1&token=${this.token}`
						)
					}
				}
			},
			// 不满足优惠券领取条件，跳转会员购买页
			handleOpenVip(id) {
				console.log(id)
				let host = window.location.host
				if (this.isIOS) {
					if (this.isHome) {
						let url = `https://${host}/h5vip/vipiospay/?id=${id}&type=1&token=${this.token}`
						console.log(url)
						this.jumpweb(url, 0, '#222224')
					} else {
						this.$router.push(
							`/vipiospay?id=${id}&type=1&fromh5=1&token=${this.token}&statictics=${this.$CONFIG.statistics}`
						)
					}
				} else {
					if (this.isHome) {
						let url = `https://${host}/h5vip/vippay/?id=${id}&type=1&token=${this.token}`
						console.log(url)
						this.jumpweb(url, 0, '#222224')
					} else {
						this.$router.push(
							`/vippay?id=${id}&type=1&fromh5=1&token=${this.token}&statictics=${this.$CONFIG.statistics}`
						)
					}
				}
			},
			// 埋点
			buryingPoint() {
				let query = {
					pagesource_var: this.pageSource
				}
				window.gio('track', 'BrowseVipDetails', query)
				window.gio('send')
			},
			handleScroll() {
				// this.scroll = document.documentElement && document.documentElement.scrollTop
				// let scroll = document.documentElement && document.documentElement.scrollTop
				let scroll = document.body.scrollTop || document.documentElement.scrollTop

				// alert(scroll, 'qq')
				if (scroll) {
					// console.log(scroll);
					window.sessionStorage.setItem('scroll', scroll)
					this.scroll = scroll
				}
				// console.log(this.scroll)
			},
			// 获取url上的信息
			getcommit(name) {
				return (
					decodeURIComponent(
						(new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
							location.href
						) || ['', ''])[1].replace(/\+/g, '%20')
					) || false
				)
			},
			// 获取token
			getToken() {
				if (this.$CONFIG.isVerify && this.isIOS) {
					this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
				} else {
					this.token = this.getcommit('token') || ''
				}
				console.log(this.token)
			},
			// 跳转登录
			gotoLogin() {
				// console.log($v);
				if (!this.token) {
					this.phoneLogin()
				}
			},
			// 两端的登录方法
			phoneLogin() {
				// 安卓登录
				try {
					window.LiveAppJS.login()
				} catch (e) {
					console.log('android login error')
				}
				// IOS登录
				try {
					window.webkit.messageHandlers.isnotlogin.postMessage('login')
				} catch (e) {
					console.log('ios login error')
				}
			},
			// 跳转两端新容器
			jumpweb(url, isTitleBar, statusColor) {
				let hasTitle
				// if (isTitleBar) {
				hasTitle = url.indexOf('/unitevip/') == -1 ? isTitleBar : 0
				let color = statusColor ?
					statusColor :
					url.indexOf('/unitevip/') == -1 ?
					'' :
					'#18181A'
				// }else{
				// hasTitle=1
				// }
				console.log(url)
				var androidParam =
					'{"url":"' +
					url +
					'","isTitleBar":"' +
					hasTitle +
					'","statusbarBg":"' +
					color +
					'"}'
				var iosParam = {
					url: url,
					isTitleBar: hasTitle,
					statusbarBg: color
				}
				try {
					window.webkit.messageHandlers.jumpWeb.postMessage(iosParam)
				} catch (e) {
					console.log('ios打开新页面失败', iosParam)
				}

				try {
					window.LiveAppJS.jumpWeb(androidParam)
				} catch (e) {
					console.log('安卓打开新页面失败', androidParam)
				}
			},
			// 获取会员信息
			getVipInfo() {
				let params = {
					statistics: this.$CONFIG.statistics,
					token: this.token
				}
				this.$vipapi.getVipMine(params).then((res) => {
					if (res.status === 200) {
						this.isLoading = false
						if (res.data.data.userInfo.length != 0) {
							this.userInfo = res.data.data.userInfo
							sessionStorage.setItem('userName', res.data.data.userInfo.userName)
						}
						this.userVipIcon = res.data.data.userVipIcon
						// 会员列表
						this.vipList = res.data.data.vipInfo
						// 会员直播
						this.vipLives = res.data.data.zhiboInfo
						// 会员专享视频
						this.vipVideos = res.data.data.likeVideo.detail
						// 会员福利社
						this.vipWelfare = res.data.data.benefits.detail
						// 会员活动
						this.vipActivity = res.data.data.activiyInfo
						// 会员兑换
						this.vipExchange = res.data.data.titleMenu ?
							res.data.data.titleMenu.titleTip :
							''
						window.console.log('会员兑换', this.vipExchange)
						// 客服信息
						this.serviceInfo = res.data.data.serviceInfo
					}
				})
			},
			// 领取优惠券
			getReceiveCoupon(id) {
				// 未登录
				if (!this.token) {
					this.phoneLogin()
				} else {
					let params = `actId=${id}&token=${this.token}&statistics=${this.$CONFIG.statistics}`
					this.$vipapi.receiveCoupon(params).then((res) => {
						// 不满足条件
						if (res.data.status === '201') {
							this.vipCouponDialogInfo = {
								num: res.data.data.vipList.length, // 1单个会员 >1多个会员
								vipList: res.data.data.vipList
							}
							this.changeCouponDialog(true)
							// console.log(res.data.msg);
						} else {
							this.info = res.data.msg
							this.showDialog(true)
						}
					})
				}
			},
			// 显示弹窗
			showDialog(visible) {
				this.dialogIsShow = visible
			},
			// 显示优惠券不满足需开通会员弹窗
			changeCouponDialog(visible) {
				this.showCouponDialog = visible
			},
			// 跳转会员兑换
			gotoExchange() {
				if (this.token) {
					if (this.isHome) {
						// 用户昵称转码
						let name = encodeURIComponent(this.userInfo.userName)
						console.log(name)
						let host = window.location.host
						let url = `https://${host}/h5vip/vipexchange/?token=${this.token}&userName=${name}`
						this.jumpweb(url, 0)
					} else {
						this.$router.push(
							`/vipexchange/?token=${this.token}&fromh5=1&userName=${this.userInfo.userName}`
						)
					}
				} else {
					this.phoneLogin()
				}
			},
			// 跳转会员支付页面
			gotoPay(id, type, item) {
				this.id = id
				this.type = type
				// 如果后台配置了版权弹窗提示
				if (item.popDesc) {
					this.title = '提示'
					this.info = item.popDesc
					this.btn = ''
					this.dialogType = 'topay'
					this.btn2 = '我知道了'
					this.showDialog(true)
				} else {
					// 如果是app首页，打开新容器
					if (this.isHome) {
						let host = window.location.host
						console.log(host)

						// 普通会员
						if (type === 1) {
							this.openPay()
						}
						// 奥沙利文
						if (type === 2) {
							// this.$router.push(`/vipstar/?id=${id}&type=1&fromh5=1&token=${this.token}`)
							let url = `https://${host}/h5vip/vipstar/?id=${id}&type=1&token=${this.token}`
							console.log(url)
							this.jumpweb(url, 0, '#222224')
						}
						// 巅峰赛事包
						if (type === 3) {
							// this.$router.push(`/vipbag/?id=${id}&type=1&fromh5=1&token=${this.token}`)
							let url = `https://${host}/h5vip/vipbag/?id=${id}&type=1&token=${this.token}`
							console.log(url)
							this.jumpweb(url, 0, '#222224')
						}
					} else {
						// 普通会员
						if (type === 1) {
							this.openPay()
						}
						// 奥沙利文
						if (type === 2) {
							this.$router.push(
								`/vipstar/?id=${id}&type=1&fromh5=1&token=${this.token}`
							)
						}
						// 巅峰赛事包
						if (type === 3) {
							this.$router.push(
								`/vipbag/?id=${id}&type=1&fromh5=1&token=${this.token}`
							)
						}
					}
				}
			},
			// 判断环境
			convertDomain(currDomain) {
				var localDomain = window.location.host
				var name = localDomain.split('.', 2)[0]
				var arr = name.split('-', 2)
				return arr.length > 1 ? arr[0] + '-' + currDomain : currDomain
			},
			// 跳转会员福利社
			gotoWelfare() {
				// 如果是app首页，打开新容器
				if (this.isHome) {
					let host = window.location.host
					let url = `https://${host}/h5vip/vipwelfare/?token=${this.token}&isHome=true`
					this.jumpweb(url, 0)
				} else {
					this.$router.push(`/vipwelfare/?token=${this.token}&fromh5=1`)
				}
			},
			// 跳转会员福利详情页
			gotoDetail(id) {
				// 未登录
				if (!this.token) {
					this.phoneLogin()
				} else {
					if (this.isHome) {
						let host = window.location.host
						let url = `https://${host}/h5vip/vipcoupon/?id= ${id}&token=${this.token}&isHome=true`
						this.jumpweb(url, 0)
					} else {
						this.$router.push(
							`/vipcoupon/?id= ${id}&token=${this.token}&fromh5=1`
						)
					}
				}
			},
			// 跳转会员视频
			gotoVIPVideo() {
				if (this.isHome) {
					let host = window.location.host
					let url = `https://${host}/h5vip/vipvideo/?token=${this.token}`
					this.jumpweb(url, 0)
				} else {
					this.$router.push(`/vipvideo/?token=${this.token}&fromh5=1`)
				}
			},
			// 跳转会员记录
			gotoRecord() {
				if (!this.token) {
					this.phoneLogin()
				} else {
					if (this.isHome) {
						let host = window.location.host
						let url = `https://${host}/h5vip/viprecord/?token=${this.token}`
						this.jumpweb(url, 0)
					} else {
						this.$router.push(`/viprecord/?token=${this.token}&fromh5=1`)
					}
					// this.$router.push(`/viprecord/?token=${this.token}`)
				}
			},
			// 跳转活动地址
			gotoAct(url) {
				// this.url = url
				// this.title = '提示'
				// this.info =
				//   "因版权问题，中国体育APP<span style='font-weight:bolder;'>无法直播全运会赛事</span>，请谨慎购买会员"
				// this.btn = ''
				// this.dialogType = 'tounion'
				// this.btn2 = '我知道了'
				// this.showDialog(true)
				this.jumpweb(url)
			},
			// 跳转视频详情
			gotoVideoDeatil(id) {
				try {
					window.webkit.messageHandlers.startVideoRoom.postMessage(id)
				} catch (e) {
					console.log('IOS跳转视频详情失败')
				}

				try {
					window.LiveAppJS.startVideoRoom(id)
				} catch (e) {
					console.log('安卓跳转视频详情失败')
				}
			},
			// 跳转直播间详情
			gotoLiveDetail(isNeed, roomId) {
				console.log(roomId)
				// 需要登录且未登录
				if (isNeed && !this.token) {
					this.phoneLogin()
				} else {
					try {
						window.webkit.messageHandlers.answerRoomNum.postMessage(roomId)
					} catch (e) {
						console.log('ios跳转直播间详情失败')
					}

					try {
						window.LiveAppJS.answerJs(roomId)
					} catch (e) {
						console.log('安卓跳转直播间详情失败')
					}
				}
			},
			// 跳转会员服务协议
			gotoVipPrivilege() {
				let url = 'http://vip.zhibo.tv/vip/privilege-explain'
				this.jumpweb(url)
				// window.location.href = "http://vip.zhibo.tv/vip/privilege-explain"
			},
			// 跳转会员帮助
			gotoVipHelp() {
				let url = 'http://static.zhibo.tv/agreement/vipHelp.html?isApp=1'
				this.jumpweb(url)
			},
			// 联系客服
			callKefu() {
				if (!this.token) {
					this.phoneLogin()
				} else {
					window.console.log(this.serviceInfo)
					let sedata = {
						userId: this.serviceInfo.userId,
						userHeadImg: this.serviceInfo.userHeadImg,
						username: this.serviceInfo.userName
						// phoneNumber: this.serviceInfo.telPhone
					}

					try {
						window.webkit.messageHandlers.systemService.postMessage(sedata)
					} catch (e) {
						window.console.log('ios拉起联系客服失败', sedata)
					}
					try {
						window.LiveAppJS.systemService(
							this.serviceInfo.userId,
							this.serviceInfo.userName,
							this.serviceInfo.userHeadImg,
							this.serviceInfo.telPhone
						)
					} catch (e) {
						window.console.log(
							'Android拉起联系客服失败',
							this.serviceInfo.userId,
							this.serviceInfo.userName,
							this.serviceInfo.userHeadImg,
							this.serviceInfo.telPhone
						)
					}
				}
			}
		},
		filters: {
			TotalTimeFilter(val) {
				let seconds = val % 60 > 10 ? val % 60 : '0' + (val % 60)
				let minutes =
					Math.floor(((val - seconds) / 60) % 60) > 10 ?
					Math.floor(((val - seconds) / 60) % 60) :
					'0' + Math.floor(((val - seconds) / 60) % 60)
				let hours =
					Math.floor(val / 60 / 60) > 10 ?
					Math.floor(val / 60 / 60) :
					'0' + Math.floor(val / 60 / 60)

				let result
				if (hours === '00') {
					result = `${minutes}:${seconds}`
				} else {
					result = `${hours}:${minutes}:${seconds}`
				}
				return result
			}
		}
	}
</script>
<style lang="less" scoped>
	@import url('../style/index.less');

	.home {
		padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
		padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
		font-size: 0.24rem;

		.isReady {
			width: 7.5rem;
			min-height: 100vh;
			margin: 0 auto;
			background: url('https://images.zhibo.tv/2020/1106/vipbigbg.png') no-repeat 0 0.88rem;
			background-size: 100%;
		}

		.bgTop {
			width: 7.5rem;
			min-height: 100vh;
			margin: 0 auto;
			background: url('https://images.zhibo.tv/2020/1106/vipbigbg.png') no-repeat 0 top;
			background-size: 100%;
		}

		.isLoading {
			width: 0.48rem;
			height: 0.48rem;
			margin: 0 auto;
			margin-top: 7.2rem;

			img {
				display: block;
				width: 0.48rem;
				height: 0.48rem;
				animation: rotate 2s linear infinite;
			}
		}

		@keyframes rotate {
			0% {
				transform: rotateZ(0deg);
				/*从0度开始*/
			}

			100% {
				transform: rotateZ(360deg);
				/*360度结束*/
			}
		}

		// background:pink;
		// 统一样式
		.contents {
			padding: 0 0.3rem;
		}

		.norp {
			padding-right: 0;
		}

		// 个人中心
		.userInfo {
			width: 100%;
			// height:3.2rem;
			padding: 0;

			// background:#222223;
			.infoMain {
				background: #222223;
				padding: 0.3rem 0.3rem 0.4rem 0.3rem;
				display: flex;
				justify-content: space-between;
				align-items: center;

				// 头像
				.userImg {
					width: 0.94rem;
					height: 0.94rem;

					margin-right: 0.2rem;
					border-radius: 50%;
					background: url('https://images.zhibo.tv/2021/0312/icon_logo.png') #393939 no-repeat center center;
					background-size: 100%;

					// border: 0.02rem solid #d8bea4;
					img {
						display: block;
						width: 0.94rem;
						height: 0.94rem;
						border-radius: 50%;
						// border: 0.02rem solid #d8bea4;
					}

					.borImg {
						border: 0.02rem solid #d8bea4;
					}
				}

				// 昵称
				.vipInfo {
					flex: 1;
					height: 0.85rem;
					display: flex;
					flex-direction: column;
					// justify-content: space-between;
					align-items: flex-start;

					.userName {
						margin-bottom: 0.06rem;
						// text-align: left;
						font-size: 0.32rem;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: bold;
						color: #d8bea4;
					}

					.info {
						// text-align: left;
						font-size: 0.24rem;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #d8bea4;
						line-height: 0.33rem;
					}

					// iconList
					.iconList {
						display: flex;

						.iconItem {
							width: 0.28rem;
							height: 0.28rem;
							margin-right: 0.14rem;

							img {
								display: block;
								width: 0.28rem;
								height: 0.28rem;
							}
						}
					}
				}

				// 按钮
				.handleBtn {
					width: 1.56rem;
					height: 0.62rem;
					margin-bottom: 0.03rem;
					display: flex;
					justify-content: center;
					align-items: center;
					line-height: 1;
					border-radius: 0.44rem;
					// border: 1PX solid rgba(216, 190, 164, 0.5);
					border: 0.14vw solid rgba(216, 190, 164, 0.5);

					font-size: 0.24rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #d8bea4;
				}
			}
		}

		// 会员类型
		.vipType {
			color: red;
			font-size: 0.8rem;

			.vipList {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;

				.typeItem {
					position: relative;
					width: 3.35rem;
					height: 2rem;
					// overflow-x: hidden;
					margin-bottom: 0.2rem;
					box-sizing: border-box;
					padding: 0.35rem 0.2rem 0.2rem 0.3rem;
					// display: flex;
					// flex-direction: column;
					// align-items: flex-start;
					// justify-content: space-between;
					background: url('https://images.zhibo.tv/2020/1106/vipbg3.png') no-repeat;
					background-size: 100%;
					border-radius: 0.1rem;
					color: #613f25;

					.flex1 {
						margin-bottom: 0.16rem;
						// flex: 1;
						// display: flex;
						// flex-direction: column;
						// justify-content: space-between;
						// align-items: flex-start;
					}

					.vipName {
						height: 0.4rem;
						margin-bottom: 0.06rem;
						display: flex;
						// background: red;
						// justify-content: center;
						align-items: center;
						flex-wrap: nowrap;
						// width: 100%;
						font-size: 0.28rem;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: bold;
						line-height: 0.3rem;

						.icon_vip {
							width: 0.4rem;
							height: 0.4rem;
							margin-right: 0.1rem;
							// background: brown;
						}

						img {
							width: 0.4rem;
							height: 0.4rem;
							display: block;
						}

						.name {
							// background: chartreuse;
							max-width: 2.5rem;
							// height: 0.3rem;
							flex-shrink: 0;
							// margin-top: 0.03rem;
							display: flex;
							justify-content: flex-start;
							align-items: center;
							font-size: 0.28rem;
							font-family: PingFangSC-Medium, PingFang SC;
							font-weight: bold;
							line-height: normal;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
						}
					}

					//状态（过期时间/购买文案/已过期）
					.vipStatus {
						height: 0.3rem;
						font-size: 0.22rem;
						font-family: PingFangSC-Light, PingFang SC;
						font-weight: 300;
						color: #78482e;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
						line-height: 0.3rem;
					}

					// 价格/按钮
					.handle {
						width: 100%;
						display: flex;
						justify-content: space-between;
						align-items: center;

						.price {
							display: flex;
							justify-content: center;
							align-items: baseline;
							font-size: 0.48rem;
							font-family: BebasNeue;

							letter-spacing: 0.02rem;

							span {
								font-size: 0.22rem;
								font-family: PingFang-SC-Regular, PingFang-SC;
								font-weight: 400;
							}
						}

						.handleBtn {
							width: 1.08rem;
							height: 0.46rem;
							margin-bottom: 0.03rem;
							display: flex;
							justify-content: center;
							align-items: center;

							border-radius: 0.3rem;
							border: 0.14vw solid #bf8e67;
							// .border-all (1px,solid,#bf8e67,30px);
							font-size: 0.24rem;
							font-family: PingFangSC-Medium, PingFang SC;
							font-weight: 500;
							line-height: normal;
							text-align: center;
						}

						.longWidth {
							width: 100%;
						}
					}

					// 续费优惠
					.renew {
						// width: 1.2rem;
						// height: 0.37rem;
						padding: 0.02rem 0.12rem;
						position: absolute;
						right: 0rem;
						top: -0.1rem;
						background: linear-gradient(135deg,
								#ff6777 0%,
								#fb7d54 47%,
								#ee4f46 100%);
						border-radius: 0rem 0.12rem 0rem 0.12rem;
						// border-radius: 0.02rem 1rem 0.02rem 1rem;

						font-size: 0.24rem;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #fff;
						text-shadow: 0 0.02rem 0.04rem rgba(255, 0, 0, 0.5);
					}
				}

				// 奇数第一个
				.firstOdd {
					background: url('https://images.zhibo.tv/2020/1106/vipbg2.png') no-repeat;
					background-size: 100%;
					color: #d8bea4 !important;

					.vipStatus {
						color: #d8bea4;
					}

					border: none;

					.handle .handleBtn {
						border: none;
						color: #613f25;
						background: linear-gradient(135deg,
								#f3e7d8 0%,
								#ead4bc 68%,
								#f6e5c9 100%);
					}
				}

				.firstEven {
					width: 6.9rem;
					height: 2rem;
					padding: 0.45rem 0.3rem 0.4rem 0.3rem;
					background: url('https://images.zhibo.tv/2020/1106/vipbg1.png') no-repeat;
					background-size: 100%;
					color: #d8bea4 !important;
					display: flex;
					flex-direction: row;

					.flex1 {
						flex: 1;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						// height: 100%;
						font-size: 0.36rem;

						// margin-top: 0.25rem;
						.vipName {
							margin-bottom: 0.18rem;

							.name {
								max-width: 5rem;
								font-size: 0.36rem;
								// line-height: 0.36rem;
							}
						}
					}

					.vipStatus {
						width: 4.7rem;
						height: 0.26rem;
						font-size: 0.26rem;
						color: #d8bea4;
						overflow: hidden;
					}

					.handle {
						width: auto;
						height: 100%;
						flex-direction: column;

						.handleBtn {
							border: none;
							color: #613f25;
							background: linear-gradient(135deg,
									#f3e7d8 0%,
									#ead4bc 68%,
									#f6e5c9 100%);
						}
					}
				}
			}
		}

		// 会员活动
		.activity {
			width: 100%;
			padding: 0.3rem 0;

			.title {
				position: absolute;
				width: 100%;
				text-align: center;
				bottom: 0.3rem;
				left: 50%;
				transform: translate(-50%);
				font-size: 0.32rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
				line-height: 0.45rem;
				text-shadow: 0 0.02rem 0.22rem rgba(64, 71, 177, 0.5);
				z-index: 3;
			}

			// 一个活动
			.pic1 {
				width: 100%;
				height: 1.77rem;
				border-radius: 0.1rem;
				overflow: hidden;
				position: relative;

				img {
					width: 100%;
					height: 1.77rem;
					border-radius: 0.1rem;
					object-fit: cover;
				}

				.cover {
					position: absolute;
					width: 100%;
					height: 0.7rem;
					bottom: 0;
					left: 0;
					background: linear-gradient(360deg,
							rgba(0, 0, 0, 0.66) 0%,
							rgba(0, 0, 0, 0) 100%);
				}
			}

			// 两个活动
			.pic2 {
				display: flex;
				justify-content: space-between;

				.picItem {
					width: 3.4rem;
					height: 1.88rem;
					border-radius: 0.1rem;
					position: relative;
					overflow: hidden;

					img {
						width: 3.4rem;
						height: 1.88rem;
						border-radius: 0.1rem;
						object-fit: cover;
					}

					.cover {
						position: absolute;
						width: 100%;
						height: 0.7rem;
						bottom: 0;
						left: 0;
						background: linear-gradient(360deg,
								rgba(0, 0, 0, 0.66) 0%,
								rgba(0, 0, 0, 0) 100%);
					}
				}
			}

			// 多个活动
			.picmore {
				height: 1.77rem;
				// display: flex;
				overflow-x: scroll;
				white-space: nowrap;
				font-size: 0;

				&::-webkit-scrollbar {
					display: none;
					/* Chrome Safari */
				}

				// &::after {
				//   content: '';
				//   display: table;
				//   width: 0.2rem;
				//   height: 1rem;
				// }
				.picItem {
					position: relative;
					width: 3.2rem;
					height: 1.77rem;
					border-radius: 0.1rem;
					margin-right: 0.1rem;
					overflow: hidden;
					display: inline-flex;
					background: url('https://images.zhibo.tv/2020/0416/defimg.png') no-repeat center center;
					background-size: 60%;

					img {
						width: 3.2rem;
						height: 1.77rem;
						border-radius: 0.1rem;
						object-fit: cover;
					}

					.cover {
						position: absolute;
						width: 100%;
						height: 0.7rem;
						bottom: 0;
						left: 0;
						background: linear-gradient(360deg,
								rgba(0, 0, 0, 0.66) 0%,
								rgba(0, 0, 0, 0) 100%);
					}
				}

				// & :last-child {
				//   margin-right: 0.3rem;
				// }
			}
		}

		// 统一样式
		.titleSty {
			display: flex;
			justify-content: space-between;
			margin-bottom: 0.3rem;

			// 标题
			.title {
				font-size: 0.34rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: bold;
				color: #222222;
			}

			// 更多
			.more {
				font-size: 0.28rem;
				font-family: PingFangSC-Light, PingFang SC;
				font-weight: 300;
				color: #999999;

				i {
					display: inline-block;
					width: 0.09rem;
					height: 0.16rem;
					background: url('https://images.zhibo.tv/2020/1103/icon_moreRight@2x.png') no-repeat;
					background-size: 100%;
				}
			}
		}

		// 会员福利社
		.vipWelfare {
			padding: 0.3rem 0;

			.couponsList {
				display: flex;
				justify-content: space-between;

				.couponItem {
					width: 3.35rem;
					height: 1.72rem;
					overflow: hidden;
					display: flex;
					justify-content: space-between;
					border-radius: 0.1rem;
					background: url('https://images.zhibo.tv/2020/1106/couponbg1.png') no-repeat;
					background-size: 100%;

					.leftInfo {
						flex: 1;
						display: flex;
						align-items: center;
						flex-direction: column;
						justify-content: center;
						padding: 0 0.2rem;

						.couponPrice {
							height: 0.8rem;
							display: flex;
							justify-content: center;
							align-items: center;

							.num {
								margin-right: 0.06rem;
								font-size: 0.8rem;
								font-family: BebasNeue;
								color: #ff543a;

								span {
									font-size: 0.24rem;
									font-family: PingFang-SC-Regular, PingFang-SC;
									font-weight: 400;
								}
							}

							.other {
								.word {
									font-size: 0.2rem;
									font-family: PingFangSC-Medium, PingFang SC;
									font-weight: 500;
									color: #613f25;
								}

								.man {
									font-size: 0.2rem;
									font-family: PingFang-SC-Regular, PingFang-SC;
									font-weight: 400;
									color: #613f25;
								}
							}
						}

						.condition {
							font-size: 0.2rem;
							font-family: PingFang-SC-Regular, PingFang-SC;
							font-weight: 400;
							color: #613f25;

							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
						}
					}

					.rightInfo {
						width: 0.52rem;
						padding: 0.3rem 0.14rem;
						position: relative;
						box-sizing: border-box;
						font-size: 0.24rem;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 700;
						color: #613f25;
						line-height: 0.28rem;
					}
				}
			}
		}

		// 会员权益
		.vipRights {
			padding: 0.3rem 0;

			.rightsBox {
				width: 6.9rem;
				height: 5.68rem;
				display: flex;
				flex-wrap: wrap;
				background: #fcf9f5;
				border-radius: 0.1rem;
				box-sizing: border-box;
				padding: 0.48rem 0 0.3rem 0;

				.rightsItem {
					height: 1.38rem;
					margin-bottom: 0.38rem;
					display: flex;
					justify-content: center;
					align-items: center;
					flex-direction: column;

					flex-shrink: 0;
					width: calc(100% / 3);

					.itemIcon {
						width: 0.9rem;
						height: 0.9rem;
						margin-bottom: 0.14rem;

						img {
							display: block;
							width: 0.9rem;
							height: 0.9rem;
						}
					}

					.itemName {
						font-size: 0.24rem;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #613f25;
					}
				}
			}
		}

		// 会员直播
		.vipLives {
			padding-top: 0.3rem;

			.livesBox {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				margin-bottom: 0.4rem;

				.liveItem {
					width: 3.38rem;
					height: 3rem;
					overflow: hidden;
					border: 0.01rem solid #e5e5e5;
					box-shadow: 0 0.01rem 0.2rem 0.02rem rgba(88, 88, 88, 0.1);
					border-radius: 0.1rem;
					margin-bottom: 0.2rem;

					// 封面
					.poster {
						width: 100%;
						height: 1.9rem;
						position: relative;
						background: url('https://images.zhibo.tv/2020/0416/defimg.png') no-repeat center center;
						background-size: 60%;

						img {
							display: block;
							width: 100%;
							height: 1.9rem;
							object-fit: cover;
						}

						.icon_living {
							width: 1rem;
							height: 0.3rem;
							position: absolute;
							top: 0.1rem;
							right: 0.1rem;
							background: url('https://images.zhibo.tv/2020/1104/icon_liveing@2x.png') no-repeat;
							background-size: 100%;
						}
					}

					// 下边信息
					.liveInfo {
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						text-align: left;
						box-sizing: border-box;
						padding: 0.15rem 0.1rem;
						height: 1.1rem;

						// 标题
						.liveTitle {
							font-size: 0.28rem;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
						}

						.otherInfo {
							display: flex;
							justify-content: space-between;
							align-items: baseline;
							font-size: 0.22rem;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;

							.anchorName {
								max-width: 100px;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}

							.hot {
								display: flex;
								align-items: center;

								.icon_hot {
									width: 0.18rem;
									height: 0.2rem;
									margin-right: 0.1rem;
									display: inline-block;
									background: url('https://images.zhibo.tv/2020/1104/icon_hot@2x.png') no-repeat;
									background-size: 100%;
								}
							}
						}
					}
				}

				// 第一个直播
				.firstLive {
					width: 100%;
					height: 4.96rem;
					// border: none;
					flex-shrink: 0;

					// margin-bottom: 0.44rem;
					// box-shadow: none;
					.poster {
						height: 3.9rem;
						// border-radius: 0.1rem;
						overflow: hidden;

						img {
							height: 3.9rem;
							// border-radius: 0.1rem;
							object-fit: cover;
						}
					}

					.liveInfo {
						padding: 0.1rem 0.2rem 0.2rem 0.2rem;
					}
				}
			}
		}

		// 会员专享视频
		.vipVideos {
			.videosBox {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				margin-bottom: 0.1rem;

				.videoItem {
					flex-shrink: 0;
					width: 3.38rem;
					height: 3rem;
					margin-bottom: 0.2rem;
					overflow: hidden;
					background: #ffffff;
					border-radius: 0.1rem;
					border: 0.01rem solid #e5e5e5;
					box-shadow: 0 0.01rem 0.2rem 0.02rem rgba(88, 88, 88, 0.1);

					.poster {
						width: 3.4rem;
						height: 1.9rem;
						border-radius: 0.1rem 0.1rem 0 0;
						position: relative;
						background: url('https://images.zhibo.tv/2020/0416/defimg.png') no-repeat center center;
						background-size: 60%;

						img {
							width: 3.4rem;
							height: 1.9rem;
							object-fit: cover;
						}

						.icon_vip {
							width: 0.8rem;
							height: 0.3rem;
							position: absolute;
							top: 0.1rem;
							right: 0.1rem;
							background: url('https://images.zhibo.tv/2020/1104/icon_vip@2x.png') no-repeat;
							background-size: 100%;
						}

						.cover {
							position: absolute;
							width: 100%;
							height: 0.7rem;
							bottom: 0;
							left: 0;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: flex-end;
							background: linear-gradient(360deg,
									rgba(0, 0, 0, 0.66) 0%,
									rgba(0, 0, 0, 0) 100%);

							font-size: 0.22rem;
							font-family: PingFangSC-Medium, PingFang SC;
							font-weight: 500;
							color: #ffffff;

							.time {
								margin-right: 0.1rem;
								margin-top: 0.3rem;
							}
						}
					}

					.title {
						margin: 0.15rem 0.1rem;
						text-align: left;
						font-size: 0.28rem;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
						line-height: 0.4rem;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
					}
				}
			}
		}

		// 其他服务
		.serves {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			margin-bottom: 0.1rem;
			margin-top: 0.3rem;

			.serveItem {
				flex-shrink: 0;
				width: 3.35rem;
				height: 0.6rem;
				margin-bottom: 0.2rem;
				display: flex;
				justify-content: center;
				align-items: center;
				background: #f7f7f7;
				border-radius: 0.06rem;

				font-size: 0.24rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
			}
		}
	}
</style>
